<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title>{{'testId.TabItems.settings.heading' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
      <button mat-icon-button mat-dialog-close aria-label="Close Dialog"><mat-icon>close</mat-icon></button>
    </div>
  </div>
  <form [formGroup]="instructionForm" class="instruction-form-wrap">
    <div class="input-wrapper">
      <div class="input-label">
        <label>{{'testId.TabItems.settings.labelItemName' | translate}}</label>
      </div>
      <div class="input-field">
        <input type="text" rows="1" maxlength="121" class="form-control" formControlName="itemDisplayName">
      </div>
    </div>
    <br>
    <div class="input-wrapper">
      <div class="input-label">
        <label>{{'testId.TabItems.settings.labelInstructions' | translate}}</label>
      </div>

      <mat-dialog-content class="">
        <div class="add-instruction-container">
          <div class="editor">
            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
            </ngx-editor-menu>
            <ngx-editor formControlName="instruction" placeholder="{{'testId.TabItems.settings.editorPlaceholder' | translate}}" class="form-control textarea"
              [editor]="editor">
            </ngx-editor>
          </div>
          <div *ngIf="f.instruction.errors?.maxlength" class="alert alert-danger error-message">
            {{'testId.TabItems.settings.istructionError1' | translate}}
          </div>
        </div>
      </mat-dialog-content>
    </div>
    <br>
    <!-- <div class="input-wrapper">
      <div class="input-label">
        <label>{{'testId.TabItems.settings.labelItemGroup' | translate}}</label>
      </div>

      <select aria-placeholder="Add Item group" class="form-control ng-untouched ng-pristine ng-valid"
        ng-reflect-model="" formControlName="itemCategory" [(ngModel)]="selectedCategory">
        <option *ngFor="let categoryList of categoryArray" value="{{categoryList.itemCategoryName}}">
          {{ categoryList.itemCategoryName }}
        </option>
      </select>
    </div> -->

    <mat-dialog-actions align="end">
      <!-- <button mat-flat-button class="btn-default" (click)="onClose()">Cancel</button>
      <button *ngIf="data.instructionid !== null" mat-flat-button color="" class="btn-warn"
        (click)="deleteInstruction()">Delete</button> -->
      <button [disabled]="instructionForm.controls.itemDisplayName.invalid" mat-flat-button color="" class="btn-primary"
        (click)="saveInstruction()">{{'testId.TabItems.settings.btnSave' | translate}}</button>
    </mat-dialog-actions>
  </form>
</div>
